import { createContext, useContext } from 'react'
import type { LoginResponse } from '@/lib/api/types'

export type AuthPhase = 'restoring' | 'anonymous' | 'authenticated'

export type AuthApi = {
  phase: AuthPhase
  signIn: (email: string, password: string) => Promise<LoginResponse>
  completeChallenge: (tokens: NonNullable<LoginResponse['tokens']>) => void
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthApi | null>(null)

export const useAuth = (): AuthApi => {
  const api = useContext(AuthContext)

  if (api === null) {
    throw new Error('useAuth must be used inside <AuthProvider>')
  }

  return api
}
